import React from 'react'
import { useState, useEffect } from 'react'
import { useAddNewUserMutation } from './usersApiSlice'
import {useNavigate} from 'react-router-dom'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSave} from '@fortawesome/free-solid-svg-icons'
import {ROLES} from '../../config/roles'

const USER_REGEX = /^[A-z]{3,20}$/
const PWD_REGEX = /^[A-z0-9!@#$%]{4,12}$/


const NewUserForm = () => {
    const [addNewUser,{
        isLoading,
        isError,
        isSuccess,
        error
    }] = useAddNewUserMutation()

    const navigate = useNavigate()

    const [username, setUserName] = useState('')
    const [validUsername, setValidUserName] = useState(false)
    const [password, setPassword] = useState('')
    const [validPassword, setValidPassword] = useState(false)
    const [roles, setRoles] = useState(["Employee"])

    useEffect(()=>{
        setValidUserName(USER_REGEX.test(username))
    },[username])

    useEffect(()=>{
        setValidPassword(PWD_REGEX.test(password))
    },[password])

    useEffect(()=>{
        if(isSuccess){
            setUserName('')
            setPassword('')
            setRoles([])
            navigate('/dash/users')
        }
    },[isSuccess,navigate])

    const onUsernameChanged = e=> setUserName(e.target.value)
    const onPasswordChanged = e => setPassword(e.target.value)
    const onRolesChanged = e => {
        const values = Array.from(e.target.selectedOptions,  //HTML collections
            (option) => option.value
        )
        setRoles(values)
    }

    const canSave = [roles.values, validUsername, validPassword ].every(Boolean) && !isLoading
    const onSaveUserClicked = async (e) =>{
        e.preventDefault()
        if(canSave){
            await addNewUser({username, password, roles})
        }
    }
    const options = Object.values(ROLES).map(role => {
        return (
            <option key={role} value={role} > 
            {role}
            </option>

        )
    })
    const errClass = isError ? "errmsg" : "offscreen"
    const validUserClass = !validUsername ? 'form__input--incomplete' : ''
    const validPwdClass = !validPassword ? 'form__input--incomplete' : ''
    const validRolesClass = !Boolean(roles.length) ? 'form__input--incomplete' : ''

    const content = (
        <>
            <p className={errClass}> {error?.data?.message}</p>
            <form className='form' onSubmit={onSaveUserClicked}> 
                <div className='form__title-row'>
                    <h2>New User</h2>
                    <div className='form__action-buttons'> 
                        <button 
                        className='icon-button'
                        title='Save'
                        disabled={!canSave}
                        ><FontAwesomeIcon icon={faSave}/></button>
                    </div>
                </div>
                <label className='form__label' htmlFor='username'>
                    Username: <span className='nowrap'>[3-20 letters]</span>
                </label>
                <input className={`form__input ${validUserClass}`}
                id='username'
                name='username'
                type='text'
                value={username}
                autoComplete='off'
                onChange={onUsernameChanged}
                ></input>
                <label className='form__label' htmlFor='password'>Password: <span className='nowrap'>[4-12 chars incl. !@#$%]</span> </label>
                <input className={`form__input ${validPwdClass}`}
                id='password'
                name='password'
                type='password'
                value={password}
                onChange={onPasswordChanged}
                ></input>
                <label className='form__label' htmlFor='roles'>
                    ASSIGNED ROLES:  
                
                <select className={`form__select ${validRolesClass}`}
                id='roles'
                name='roles'
                multiple={true}
                size={3}
                value={roles}
                onChange={onRolesChanged}
                >{options}</select></label>
            </form>
        
        </>
    )


  return content
}

export default NewUserForm